import type { Job } from 'src/context/api/data/api';
import { toUtcTimestamp } from './notifications.utils';

// Brand Infringement per-domain exports report their own success and failure on
// the page, synchronously, with the backend's message. `/traffic/export/jobs` is
// not filtered by action, so they must be dropped here or the poller adds a
// second, contradictory toast up to 15s after the first.
const SELF_REPORTED_ACTIONS: Job['action'][] = ['bi:trademark-export'];

// Split raw export jobs into "active" (still in flight) and "failed" (never
// listed — surfaced only as an ephemeral toast).
export function splitExportJobs(jobs: Job[] = []): { active: Job[]; failed: Job[] } {
  const owned = jobs.filter((j) => !SELF_REPORTED_ACTIONS.includes(j.action));
  const active = owned.filter((j) => ['running', 'pending', 'created'].includes(j.status));
  const failed = owned.filter((j) => j.status === 'failed');
  return { active, failed };
}

// An export still in flight after this long is stuck (its worker died): it
// must not keep the notifications on fast polling for good.
const STUCK_JOB_AGE_MS = 15 * 60 * 1000;

export function hasActiveExportJob(jobs: Job[] = [], now: Date = new Date()): boolean {
  return splitExportJobs(jobs).active.some((job) => {
    const createdAt = toUtcTimestamp(job.created_at);
    return Number.isNaN(createdAt) || now.getTime() - createdAt < STUCK_JOB_AGE_MS;
  });
}
